import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class DepositService {

  url=ConfigService.toApiUrl("v1/deposits/");

  constructor(private http:HttpClient) { }

    getAll(query?:any){
      if (query) {
        let url=`${this.url}?`;
        for (const key in query) {
          if (Object.prototype.hasOwnProperty.call(query, key)) {
            const element = query[key];
            url=`${url}${key}=${element}&`
          }
        }
        return this.http.get<any[]>(`${url}`);

      } else {
        return this.http.get<any[]>(`${this.url}`);

      }
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("deposits-by-state")}/${state}`);
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  update(id:any,ressource:any){
    ressource['_method']='patch';
    //ressource.append('_method','patch');

    return this.http.post<any>(`${this.url}${id}`, ressource,  ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName),true));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("deposits-set-state")}/${id}/state/${state}`);
  }
}
